import PaymentsTableForAddons from './PaymentsTableForAddons'

export default PaymentsTableForAddons